<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des chargements des fichiers</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <b-row>
            <b-col md="2" class="mt-2">
              <span>Chargement fichier :</span>
            </b-col>
            <b-col md="5">
              <b-form-group label-for='nom_fichier'>
                <b-form-file placeholder="Joindre un fichier"
                             class="file-input"
                             drop-placeholder="Déposer le fichier ici..."
                             browse-text="Parcourir"
                             :state="errors.attachment !== '' ? false : null"
                             @change="addFile($event)">
                </b-form-file>
                <span class="field-error">{{ errors.attachment }}</span>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-button type="enter" @click.prevent="importFile" size="md" variant="primary">
                <i class="fa fa-upload"></i> Importer
              </b-button>
            </b-col>
          </b-row>
          <!-- <v-client-table v-if="dataIsReady" class="mt-4" :columns="columns" :data="items" :options="options">
            <div v-if="props.row.date_import" slot="date_import" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ formatDate(props.row.date_import) }}</span>
            </div>
            <div v-if="props.row.nom_gestionnaire" slot="nom_gestionnaire" slot-scope="props">
              {{ props.row.nom_gestionnaire }} {{ props.row.prenom_gestionnaire }}
            </div>
            <div v-if="props.row.min_date_periode" slot="min_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.min_date_periode) }}
            </div>
            <div v-if="props.row.max_date_periode" slot="max_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.max_date_periode) }}
            </div>
            <div v-if="props.row.nom_fichier" slot="nom_fichier" slot-scope="props">
              {{ props.row.nom_fichier }} <i v-if="!isEmpty(props.row.chemin)" class="ml-2 fa fa-download clickable" @click="downloadFile(props.row)"></i>
            </div>
            <div slot="nb_lignes_ok" slot-scope="props">
              <span class="badge badge-success p-2 mr-2" v-if="props.row.nb_lignes_ok !== 0"> {{ props.row.nb_lignes_ok }} OK </span>
              <span class="badge badge-warning p-2" v-if="props.row.nb_lignes_ok !== 0 && props.row.nb_lignes_ok < props.row.nb_lignes_total"> {{ (props.row.nb_lignes_total * 1) - (props.row.nb_lignes_ok * 1)  }} KO</span>
              <span class="badge badge-danger p-2" v-if="props.row.nb_lignes_ok === 0">{{ props.row.nb_lignes_total }} KO</span>
            </div>
            <div slot="action" slot-scope="props">
              <b-button v-if="props.row.rapport_chargement_module_prev.length > 0" type="button"
                        @click.prevent="seeErrors(props.row.id)" class="badge badge-info mr-3 p-2">
                <i class="fa fa-eye"></i> Voir
              </b-button>
            </div>
          </v-client-table> -->
          <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options" style="overflow: hidden;">
            <div v-if="props.row.date_import" slot="date_import" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ formatDate(props.row.date_import) }}</span>
            </div>
            <div v-if="props.row.nom_gestionnaire" slot="nom_gestionnaire" slot-scope="props">
              {{ props.row.nom_gestionnaire }} {{ props.row.prenom_gestionnaire }}
            </div>
            <div v-if="props.row.min_date_periode" slot="min_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.min_date_periode) }}
            </div>
            <div v-if="props.row.max_date_periode" slot="max_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.max_date_periode) }}
            </div>
            <div v-if="props.row.nom_fichier" slot="nom_fichier" slot-scope="props">
              {{ props.row.nom_fichier }} <i v-if="!isEmpty(props.row.chemin)" class="ml-2 fa fa-download clickable" @click="downloadFile(props.row)"></i>
            </div>
            <div slot="nb_lignes_ok" slot-scope="props">
              <span class="badge badge-success p-2 mr-2" v-if="props.row.nb_lignes_ok !== 0"> {{ props.row.nb_lignes_ok }} OK </span>
              <span class="badge badge-warning p-2" v-if="props.row.nb_lignes_ok !== 0 && props.row.nb_lignes_ok < props.row.nb_lignes_total"> {{ (props.row.nb_lignes_total * 1) - (props.row.nb_lignes_ok * 1)  }} KO</span>
              <span class="badge badge-danger p-2" v-if="props.row.nb_lignes_ok === 0">{{ props.row.nb_lignes_total }} KO</span>
            </div>
            <div slot="action" slot-scope="props">
              <b-button v-if="props.row.rapport_chargement_module_prev.length > 0" type="button"
                        @click.prevent="seeErrors(props.row.id)" class="badge badge-info mr-3 p-2">
                <i class="fa fa-eye"></i> Voir
              </b-button>
            </div>
          </v-server-table>
          <!-- <b-row>
            <b-button type="enter" @click.prevent="manageStock()" size="md" variant="primary">
                <i class="fa fa-upload"></i> Lancer le script de gestion du stock de prolongation
              </b-button>
          </b-row> -->
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {hasRule, espaceGestionRules} from "@/utils/rulesHelper";
  import {isEmpty, downloadFile} from "@/utils/fileHelper";
  import moment from 'moment';

  export default {
    name: "List",
    data() {
      let self = this;
      return {
        isEmpty,
        url: '',
        rules: espaceGestionRules,
        dataIsReady: false,
        attachment: null,
        errors: {
          attachment: '',
        },
        columns: ['date_import', 'nom_gestionnaire', 'profil_gestionnaire', 'min_date_periode', 'max_date_periode', 'nom_fichier', 'nb_lignes_ok', 'action'],
        items: [],
        options: {
          headings: {
            date_import: 'Date import',
            nom_gestionnaire: 'Nom Prénom',
            profil_gestionnaire: 'Profil utilisateur',
            min_date_periode: 'Min date période',
            max_date_periode: 'Max date période',
            nom_fichier: 'Nom du Fichier',
            nb_lignes_ok: 'Nb de lignes /\nStatut',
            action: 'Rapport',
          },
          perPage: 10,
          filterable: false,
          sortable: [],
          perPageValues: [10, 25, 50],
          requestFunction: function (data) {
            self.url = '/espaceGestion/module_prev/getHistoriqueChargement'
            self.$store.commit("IS_LOADING", true);
            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                self.$store.commit('IS_LOADING', false)
                return response;
              })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();

      // this.all();
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      importFile() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let formData = new FormData();
          formData.append('file', this.attachment);
          this.$axios
            .post(`/espaceGestion/module_prev/import`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$refs['table'].refresh();
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Ajout avec succès',
                text: "L'import a bien été fait",
                showConfirmButton: false,
                timer: 3000
              });
            })
            .catch(() => {
              this.handleErrors();

            });
        }
      },
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/module_prev/getHistoriqueChargement")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.attachment === null) {
          this.errors.attachment = "Veuillez choisir un fichier";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.attachment = "";
      },
      seeErrors(chargement_id) {
        window.open(`/espace-gestion/module-prev/rapport/${chargement_id}`, '_blank');
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      canExecute(rule) {
        return hasRule(rule);
      },
      displayPopup(type, title, text) {
        this.$swal({
          position: 'top',
          type: type,
          title: title,
          text: text,
          showConfirmButton: false,
          timer: 3000
        });
      },
      manageStock() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/module_prev/manage-stock")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            console.log(response)
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      downloadFile(row) {
        let self = this;
        let name = row.nom_fichier.split('.')[0];
        let ext = 'csv';
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/module_prev/downloadFichierRejet/'+ row.id, {responseType: 'blob'})
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, name, ext);
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant la récupération du fichier, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
    }
  }
</script>
